import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      common: {
        ...store.getState().i18n.translations.en.common,
        buyPackage: {
          USE_PACKAGE_DISCOUNT: 'Use package to get trade discount',
          UP_TO: 'up to',
          BUY_PACKAGE: 'Buy package',
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      common: {
        ...store.getState().i18n.translations.vi.common,
        buyPackage: {
          USE_PACKAGE_DISCOUNT: 'Sử dụng gói để nhận ưu đãi',
          UP_TO: 'lên đến',
          BUY_PACKAGE: 'Mua gói',
        },
      },
    },
  }),
)
